import * as React from 'react';

import { cn } from './utils';

/**
 * Input — styled per Pelipost UX/UI Style Guide §8.
 *
 *   - 1px border (colors.border), 16px border radius
 *   - White background, min height 56px
 *   - Placeholder: colors.textMuted
 *   - Focus: border changes to colors.brand, 1.5px
 *   - Error (aria-invalid): border changes to colors.error
 *   - Font size 16px (prevents iOS zoom)
 *   - Horizontal padding 12px (spacing.md)
 */
/**
 * Uses `forwardRef` so React Hook Form's `register()` (and any other ref
 * consumer, e.g. focus management) can attach to the underlying input.
 * Without it, RHF's `values` option and DOM-level reset cannot sync the
 * displayed value when the server-driven form is populated after mount.
 */
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  function Input({ className, type, ...props }, ref) {
    return (
      <input
        ref={ref}
        type={type}
        data-slot="input"
        className={cn(
          'flex min-h-14 w-full rounded-[16px] border border-border bg-surface px-3 py-2 text-base text-text',
          'placeholder:text-text-muted',
          'transition-colors outline-none',
          'focus:border-brand focus:border-[1.5px]',
          'aria-invalid:border-error aria-invalid:focus:border-error',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'file:inline-flex file:h-auto file:border-0 file:bg-transparent file:text-sm file:font-medium',
          className,
        )}
        {...props}
      />
    );
  },
);

export { Input };
